import React from 'react';
import '../styles/mobile-coverlettergen.css';

const MobileCoverLetterGen = ({ formData, handleInputChange, handleCoverLetterGenerate, isLoading }) => {
  return (
    <div className="mobile-cover-letter-container">
      <div className="mobile-cover-letter-inputs">
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="jobDescription">Job Description</label>
          </div>
          <div className="input-container">
            <textarea
              id="jobDescription"
              name="jobDescription"
              value={formData.jobDescription || ''}
              onChange={handleInputChange}
              placeholder="Briefly describe the job position..."
              className="input-field-style"
              rows={3}
            />
          </div>
        </div>
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="companyName">Company Name</label>
          </div>
          <div className="input-container">
            <input
              id="companyName"
              name="companyName"
              value={formData.companyName || ''}
              onChange={handleInputChange}
              placeholder="Enter the company's name..."
              className="input-field-style"
            />
          </div>
        </div>
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="address">Your Address</label>
          </div>
          <div className="input-container">
            <input
              id="address"
              name="address"
              value={formData.address || ''}
              onChange={handleInputChange}
              placeholder="Enter your address..."
              className="input-field-style"
            />
          </div>
        </div>
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="hiringManagerName">Hiring Manager's Name</label>
          </div>
          <div className="input-container">
            <input
              id="hiringManagerName"
              name="hiringManagerName"
              value={formData.hiringManagerName || ''}
              onChange={handleInputChange}
              placeholder="Enter the hiring manager's name..."
              className="input-field-style"
            />
          </div>
        </div>
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="hiringManagerJobTitle">Hiring Manager's Job Title</label>
          </div>
          <div className="input-container">
            <input
              id="hiringManagerJobTitle"
              name="hiringManagerJobTitle"
              value={formData.hiringManagerJobTitle || ''}
              onChange={handleInputChange}
              placeholder="Enter the hiring manager's job title..."
              className="input-field-style"
            />
          </div>
        </div>
        <div className="input-group">
          <div className="label-container">
            <label htmlFor="coverLetterBody">Cover Letter Body</label>
          </div>
          <div className="input-container">
            <textarea
              id="coverLetterBody"
              name="coverLetterBody"
              value={formData.coverLetterBody || ''}
              onChange={handleInputChange}
              placeholder="This is where your generated cover letter will appear..."
              className="input-field-style"
              rows={5}
            />
          </div>
        </div>
      </div>
      <button
        className="section-generate-btn"
        onClick={handleCoverLetterGenerate}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <div className="spinner"></div>
            <span>Generating Cover Letter...</span>
          </>
        ) : (
          <span>⚡ Generate Cover Letter</span>
        )}
      </button>
    </div>
  );
};

export default MobileCoverLetterGen;
